import React from "react";
import { Button, Spin } from "antd";
import { FullscreenOutlined } from "@ant-design/icons";

export default function PdfPreviewer({
  pdfBlobUrl,
  loading = false,
  height = "400px",
}) {
  if (loading) return <Spin />;

  return (
    <>
      <div style={{ marginBottom: 8, textAlign: "center" }}>
        <Button
          icon={<FullscreenOutlined />}
          onClick={() => window.open(pdfBlobUrl, "_blank")}
          disabled={!pdfBlobUrl}
        >
          Full Screen
        </Button>
      </div>

      <div style={{ height: `${height}` }}>
        <iframe
          src={pdfBlobUrl}
          width="100%"
          height="100%"
          title="PDF Preview"
          style={{
            border: "none",
            borderRadius: 10,
          }}
        />
      </div>
    </>
  );
}
